<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.push({ name: 'cloudServerManager' })"
            >沙盒服务器管理</em
          >
          <label
            ><i class="el-icon-arrow-right"></i> {{ $route.meta.title }}</label
          >
        </div>
      </div>
      <div class="content-inner-wrapper">
        <el-form label-width="110px" label-position="right">
          <el-form-item label="订单编号：">{{ order.id }}</el-form-item>
          <el-form-item label="创建时间："
            >{{ order.create_time | formatTime }}
            <el-tag :type="order.state == 2 ? 'success' : ''">{{
              order.state | orderState
            }}</el-tag></el-form-item
          >
          <el-form-item label="订单内容："
            >{{ order.operation_type | orderType }} 服务器x{{
              order.buy_count || list.length
            }}</el-form-item
          >
          <el-form-item label="时长：">{{ order.day }}天</el-form-item>
        </el-form>
        <h3>服务器列表</h3>
        <div class="myTable-wrap">
          <el-table border stripe max-height="300" :data="list">
            <el-table-column align="center" prop="room_id" label="服务器id">
            </el-table-column>
            <el-table-column align="center" prop="player_max" label="服务器规格">
              <template slot-scope="scope">
                <span>最多容纳{{ scope.row.player_max }}人</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="room_type" label="服务器类型">
              <template slot-scope="scope">
                <span>{{ scope.row.room_type | roomType }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-row :gutter="20">
          <el-col :span="6" :offset="18">
            <el-form label-width="90px" label-position="right">
              <el-form-item label="总价：">¥{{ order.ori_money }}</el-form-item>
              <el-form-item label="优惠：">¥{{ order.subMoney }}</el-form-item>
              <el-form-item class="realMoney" label="实付款："
                >¥{{ order.money }}</el-form-item
              >
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import mixins from '../../mixins/orderDetails.mixins';
export default {
  mixins: [mixins],
};
</script>
<style src="../../style/common-pc.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
::v-deep .el-form {
  .el-form-item {
    margin-bottom: 0;
    label,
    div {
      font-size: 18px;
    }
    &.realMoney {
      div {
        font-size: 24px;
        color: red;
      }
    }
  }
}
h3 {
  font-size: 20px;
  font-weight: bold;
  margin: 24px 0 12px;
}
.el-row {
  margin-top: 24px;
  background-color: #fff5e9;
  padding: 16px 0;
}
</style>
